import { getAppVersion } from "@components/molecules/GalleryView/utils/helpers";
import CacheBuster from "react-cache-buster";
import { ReactNode } from "react";

/** Web: must match `experiments.baseUrl` in app.config.ts so `/webapp/meta.json` resolves. */
const META_FILE_DIRECTORY = "/webapp";

export default function CacheBusterWrapper({
  children,
}: {
  children: ReactNode;
}) {
  return (
    <CacheBuster
      currentVersion={getAppVersion()}
      isEnabled={!__DEV__}
      isVerboseMode={__DEV__}
      metaFileDirectory={META_FILE_DIRECTORY}
      onCacheClear={undefined}
    >
      {children}
    </CacheBuster>
  );
}
